import styles from '../styles/Library.module.css'
import Button from './Button'
import { Tag } from '../types/Tag'
import { Image } from '../types/Image'

interface FilterTags {
  tags: Tag[]
  images: Image[]
  allTagsButton: boolean
  untaggedImages: Image[]
  untaggedButton: boolean
  selectedTag: number | null
  showAllImages: () => void, 
  showFilteredImages: (tag?: string, tagId?: number, untagged?: boolean) => void, 
}

function FilterTags({tags, images, allTagsButton, untaggedImages, untaggedButton, selectedTag, showAllImages, showFilteredImages}: FilterTags) {
  return (
    <div className={styles.tags}>
      <Button size='medium' className={allTagsButton ? styles.tagSelected : styles.tag} onClick={() => showAllImages()}>
        <span>Alla ({images.length})</span>
      </Button>
      {tags.sort((a, b) => (a.tag).localeCompare(b.tag, 'sv')).map((tag, i) => (
        <Button key={tag.tag} size='medium' className={selectedTag === i ? styles.tagSelected : styles.tag} onClick={() => showFilteredImages(tag.tag, i)} >
          <span>{tag.tag} ({tag.count})</span>
        </Button>
      ))}
      {untaggedImages.length > 0 && (
        <Button size='medium' className={untaggedButton ? styles.tagSelected : styles.tag} onClick={() => showFilteredImages('', 0, true)}>
          <span>Otaggade ({untaggedImages.length})</span>
        </Button>
      )}
    </div>
  )
}
  
export default FilterTags
  